'use client'

import { Card, Cell, Divider, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { BrandModel } from '@marketplace-web/personalization/brands-data'

import { BrandLetter } from '../types'
import BrandBox from '../BrandBox'

const BRANDS_BY_LETTER_URL = (letter: string): string => `/brands/by_letter/${letter}`

type Props = {
  letter: string
  brands: Array<BrandModel>
  hasMoreButton?: boolean
}

const BrandsByLetter = ({ letter, brands, hasMoreButton = true }: Props) => {
  const translate = useTranslate()
  const isOtherBrands = letter === BrandLetter.Other

  const brandLetter = isOtherBrands ? BrandLetter.Other : letter.toUpperCase()
  const brandTitle = isOtherBrands
    ? translate('personalization.brands.brands_by_letter.other_title')
    : letter.toUpperCase()

  function renderTitle() {
    return (
      <Cell
        title={brandTitle}
        suffix={
          hasMoreButton && !isOtherBrands ? (
            <a
              className="u-disable-underline-without-hover"
              href={BRANDS_BY_LETTER_URL(brandLetter)}
              data-testid="brands-by-letter-action-button"
            >
              {translate('personalization.brands.brands_by_letter.actions.see_all')}
            </a>
          ) : undefined
        }
      />
    )
  }

  function renderBrands() {
    return (
      <Cell>
        <div className="follow-grid">
          {brands.map(brand => (
            <BrandBox key={brand.id} brand={brand} />
          ))}
        </div>
      </Cell>
    )
  }

  if (!brands.length) return null

  return (
    <>
      <Card testId={`brands-by-letter-${letter}-card`}>
        {renderTitle()}
        <Divider />
        {renderBrands()}
      </Card>
      <Spacer size="large" />
    </>
  )
}

export default BrandsByLetter
